import { initializeApp, type FirebaseApp } from "firebase/app";
import { connectAuthEmulator, getAuth, type Auth } from "firebase/auth";
import { connectFirestoreEmulator, getFirestore, type Firestore } from "firebase/firestore/lite";
import { resolveDataMode, type ResolvedConfig } from "./dataMode.ts";

export const config: ResolvedConfig = resolveDataMode(import.meta.env);

export interface Services {
  app: FirebaseApp;
  db: Firestore;
  auth: Auth;
}

let services: Services | null = null;

/** Null in sample mode or when configuration is invalid. */
export function getServices(): Services | null {
  if (services) return services;
  if (config.mode === "sample" || !config.firebase || config.errors.length) return null;
  const app = initializeApp(config.firebase);
  const db = getFirestore(app);
  const auth = getAuth(app);
  if (config.mode === "emulator") {
    connectFirestoreEmulator(db, config.emulatorHost, 8080);
    connectAuthEmulator(auth, `http://${config.emulatorHost}:9099`, { disableWarnings: true });
  }
  services = { app, db, auth };
  return services;
}
